const STATUS_VARIANTS = {
  success: {
    background: "bg-green-500/20",
    text: "text-green-500",
    defaultLabel: "Success",
  },
  warning: {
    background: "bg-yellow-500/20",
    text: "text-yellow-500",
    defaultLabel: "Warning",
  },
  info: {
    background: "bg-blue-500/20",
    text: "text-blue-500",
    defaultLabel: "Info",
  },
  error: {
    background: "bg-red-500/10",
    text: "text-red-500",
    defaultLabel: "Error",
  },
  danger: {
    background: "bg-red-500/20",
    text: "text-red-400",
    defaultLabel: "Danger",
  },
};

const SIZE_MAP = {
  sm: "text-[10px] px-2 py-0.5",
  md: "text-xs px-3 py-1",
  lg: "text-sm px-4 py-1.5",
};

export default function StatusBadge({
  variant = "success",
  label,
  size = "md",
  className = "",
}) {
  const selectedVariant = STATUS_VARIANTS[variant] ?? STATUS_VARIANTS.success;
  const sizeClasses = SIZE_MAP[size] ?? SIZE_MAP.md;
  const text = label || selectedVariant.defaultLabel;

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${selectedVariant.background} ${selectedVariant.text} ${sizeClasses} ${className}`}
    >
      {text}
    </span>
  );
}
